import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { KeycloakService } from '../../services/keycloak.service';
import { environment } from '../../environments/environment';

/**
 * Adds the bearer token to calls to our API, and to nothing else.
 *
 * An allow-list rather than keycloak-angular's exclude-list: the hub also talks to S3 (uploads to,
 * and logos from, presigned URLs), and a presigned request that also carries an Authorization
 * header is rejected by S3 — besides handing the admin token to a third party.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private keycloak: KeycloakService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!AuthInterceptor.isApiUrl(req.url)) {
      return next.handle(req);
    }

    return from(this.keycloak.getToken()).pipe(
      switchMap(token => next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })))
    );
  }

  /** The trailing slash keeps https://api.example.com from matching https://api.example.com.evil.io. */
  static isApiUrl(url: string): boolean {
    const base = environment.api.baseUrl;
    return url === base || url.startsWith(`${base}/`);
  }
}
